<template>
  <template v-if="price && productResponse && selectedOffer">
    <slot :price :product="productResponse" :selected-offer>
      <Price
        class="grow"
        :mobile-plan="selectedMobilePlan"
        :price
        :product="productResponse"
        :selected-offer
      />
    </slot>
  </template>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import Price from '~/scopes/product-core/components/presentationals/Price/Price.vue'
import { useFetchPickers } from '~/scopes/product-core/composables/useFetch/useFetchPickers/useFetchPickers'
import { useFetchProduct } from '~/scopes/product-core/composables/useFetch/useFetchProduct/useFetchProduct'
import { useFetchProductPrice } from '~/scopes/product-core/composables/useFetch/useFetchProductPrice/useFetchProductPrice'
import { useFetchServicePickers } from '~/scopes/product-core/composables/useFetch/useFetchServicePickers/useFetchServicePickers'

const { data: productResponse } = useFetchProduct()
const { data: servicesPickersResponse } = useFetchServicePickers()
const { selectedOffer } = useFetchPickers()
const { price } = useFetchProductPrice()

const selectedMobilePlan = computed(() => {
  return (
    servicesPickersResponse.value?.pickerGroups
      ?.find(({ id }) => id === 'mobile_plan')
      ?.items?.find(({ selected }) => !!selected)?.mobilePlanOffer ?? undefined
  )
})
</script>
